import React, { useMemo } from 'react';
import cn from 'clsx';
import PropTypes from 'prop-types';

import Button from '../../library/button/button';
import Select from '../../library/select/select';
import Review from './components/review/review';

import { trackAction } from '../../shared/utils/analytics/analytics';
import { ChildrenProp } from '../../shared/utils/prop-types/prop-types';

import styles from './reviews.scss';

function Reviews(props) {
  const {
    children,
    filters,
    onFilterChange,
    onLoadMore,
    onResetFilters,
    onSortChange,
    selectedFilters,
    selectedSort,
    showLoadMore,
    sortOptions
  } = props;

  const hasSelectedFilters = useMemo(
    () => Object.keys(selectedFilters || {}).length > 0,
    [selectedFilters]
  );

  return (
    <div className={cn(styles['container'], 'reviews')}>
      <form
        aria-label="Review filter and sort"
        className={styles['filter-sort']}
      >
        <div className={styles['filters']}>
          {Array.isArray(filters) &&
            filters.map((filter, idx) => {
              let value = null;
              const selectedOption =
                typeof selectedFilters === 'object' && filter?.code
                  ? selectedFilters[filter.code]
                  : {};

              if (selectedOption?.value) {
                value = selectedOption;
              }

              return (
                <div
                  className={styles['filter-wrapper']}
                  key={`${filter?.label}-${idx}`}
                >
                  <Select
                    className="filter"
                    hideResetButton
                    label={filter?.label}
                    onChange={option => onFilterChange(option, filter)}
                    options={filter?.options?.filter(f => Boolean(f?.value))}
                    value={value}
                  />
                </div>
              );
            })}

          {hasSelectedFilters && (
            <Button className={styles['reset-link']} onClick={onResetFilters}>
              Reset filters
            </Button>
          )}
        </div>

        <Select
          className={styles['sort']}
          hideResetButton
          label="Sort"
          onChange={onSortChange}
          options={sortOptions}
          renderOption={option => (
            <div
              className={cn(
                option?.shouldResetFilter
                  ? styles['pseudo-not-selectable']
                  : '',
                'react-select__option'
              )}
            >
              {option.label}
            </div>
          )}
          value={selectedSort}
        />
      </form>
      <div className={styles['reviews']}>{children}</div>
      {showLoadMore && (
        <div className={styles['load-more']}>
          <Button
            isSecondary
            onClick={() => {
              onLoadMore();
              trackAction('product_detail_review_load_more');
            }}
          >
            Load More Reviews
          </Button>
        </div>
      )}
    </div>
  );
}

Reviews.propTypes = {
  children: ChildrenProp,
  filters: PropTypes.array,
  onFilterChange: PropTypes.func,
  onLoadMore: PropTypes.func,
  onResetFilters: PropTypes.func,
  onSortChange: PropTypes.func,
  selectedFilters: PropTypes.object,
  selectedSort: PropTypes.object,
  showLoadMore: PropTypes.bool,
  sortOptions: PropTypes.array
};

export { Review };
export default Reviews;
